import { Component } from '@angular/core';
import { DialogConfig } from 'src/app/core/components/dialog/dialog-config';
import { DialogRef } from 'src/app/core/components/dialog/dialog-ref';

@Component({
  selector: 'app-download-avviso-disclaimer',
  templateUrl: './download-avviso-disclaimer.component.html',
  styleUrls: ['./download-avviso-disclaimer.component.css']
})
export class DownloadAvvisoDisclaimerComponent {

  constructor(
    private dialogRef : DialogRef
  ) { }

  onAction(event: boolean) {
    this.dialogRef.close({modalEvent : event});
  }

}
